// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            renameForm: {
                newName: '',
            },
            rules: {
                newName: [
                    {
                        required: true,
                        message: "Image name must not be blank",
                        trigger: "blur"
                    },
                ],
            },
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetImage: function (newVal, oldVal) {
            this.renameForm.newName = newVal.name;
        }
    },

    mounted() {
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.RENAME_IMAGE);
        },

        //#region Rename image 
        rename() {
            this.$refs['renameForm'].validate(valid => {
                if (valid) {
                    this.feedStatusLoading(API_CALL_STATUS.LOADING);
                    setTimeout(() => {
                        let data = {
                            newName: this.renameForm.newName,
                            machineId: this.targetImage.id,
                            deviceInformation: JSON.stringify(this.getInformationClient())
                        }
                        api.baseRequest(SETTINGS_RENTAL_API.RENAME_IMAGE, data)
                            .then(() => {
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess('Rename success !', `Image <span style="color: #42A5F5;"> #${this.targetImage.id}</span> has been successfully renamed to <span style="color: #42A5F5;">${this.renameForm.newName}</span></span>`);
                                this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                            })
                            .catch(error => {
                                this.processCatchApiRequest(error, "Boot failed ...")
                            });
                    }, this.smoothTimeOut);
                } else {
                    return false;
                }
            });
        },
        //#endregion 
    },
}